import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

interface ChartProps {
    datasetName: string;
    dataset: {
        labels: Array<string>;
        data: Array<number>;
        backgroundColor: Array<string>;
    },
    width?: number;
    height?: number;
    legendDisplay?: boolean;
}

function BarChart({ datasetName, dataset, legendDisplay = true, width = 850, height = 275 }: ChartProps) {
    const data = {
        labels: dataset.labels,
        datasets: [
            {
                label: datasetName,
                data: dataset.data,
                backgroundColor: dataset.backgroundColor,
                borderColor: 'rgba(0, 0, 0, 0.1)',
                borderWidth: 2,
                hoverBackgroundColor: dataset.backgroundColor.map(color => `${color}CC`),
                hoverBorderColor: 'rgba(0, 0, 0, 0.2)',
                borderRadius: 8,
            }
        ]
    };

    return (
        <Bar
            data={data}
            width={width}
            height={height}
            options={{
                maintainAspectRatio: false,
                responsive: false,
                animation: {
                    duration: 1000,
                    easing: 'easeInOutQuad',
                },
                plugins: {
                    legend: {
                        display: legendDisplay,
                        align: "center",
                        position: "top",
                        labels: {
                            color: "#333",
                            font: {
                                size: 14,
                                weight: 'bold'
                            }
                        }
                    },
                    tooltip: {
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        titleColor: '#fff',
                        bodyColor: '#fff',
                        borderColor: '#777',
                        borderWidth: 1
                    }
                },
                scales: {
                    x: {
                        title: {
                            display: true,
                            text: '',
                            color: '#333',
                            font: {
                                size: 14,
                                weight: 'bold'
                            }
                        },
                        grid: {
                            display: false
                        },
                        ticks: {
                            color: '#666',
                            font: {
                                size: 12
                            }
                        }
                    },
                    y: {
                        title: {
                            display: true,
                            text: 'Total',
                            color: '#333',
                            font: {
                                size: 14,
                                weight: 'bold'
                            }
                        },
                        beginAtZero: true,
                        grid: {
                            color: 'rgba(200, 200, 200, 0.3)',
                        },
                        ticks: {
                            color: '#666',
                            font: {
                                size: 12
                            }
                        }
                    }
                }
            }}
        />
    );
}

export default BarChart;
